export const formatClockTimeInput = (inputValue: string): string => {
  let formattedValue = inputValue.replace(/[^0-9:]/g, "").slice(0, 5);

  if ((formattedValue.match(/:/g) || []).length > 1) {
    formattedValue = formattedValue.slice(0, formattedValue.lastIndexOf(":"));
  }

  if (formattedValue.includes(":")) {
    let [hours, minutes = ""] = formattedValue.split(":");

    if (hours.length === 1) {
      hours = `0${hours}`;
    }

    if (Number(hours) > 23) {
      hours = "00";
    }

    if (minutes.length > 2) {
      minutes = minutes.slice(0, 2);
    }

    if (minutes.length === 2 && Number(minutes) > 59) {
      minutes = "00";
    }

    if (minutes.length === 1 && Number(minutes) > 5) {
      minutes = "0";
    }

    return `${hours}:${minutes}`;
  }

  if (formattedValue.length === 4) {
    const hours = formattedValue.slice(0, 2);
    const minutes = formattedValue.slice(2, 4);

    if (Number(hours) > 23) {
      return "00";
    }

    if (Number(minutes) > 59) {
      return `${hours}:00`;
    }

    return `${hours}:${minutes}`;
  }

  if (formattedValue.length === 3) {
    const hours = formattedValue.slice(0, 2);
    const minuteTens = formattedValue.slice(2);

    if (Number(hours) > 23) {
      return hours;
    }

    if (Number(minuteTens) > 5) {
      return `${hours}:`;
    }

    return `${hours}:${minuteTens}`;
  }

  if (formattedValue.length === 2 && Number(formattedValue) > 23) {
    return "00";
  }

  return formattedValue;
};
